<template>
  <div>
    <BtnLauch :action="lauchScript" :isLoading="isLoading" :time="time" title="Analyze" />
    <pre style="white-space: inherit;color: white" v-html="fileContent"></pre>
    <pre v-if="result" style="white-space: inherit;color: white" v-html="result"></pre>
    <table v-if="result">
      <tr>
        <th>Platform Contract Name</th>
        <th>Platform Name</th>
        <th>Contract Name</th>
        <th>Amount</th>
        <th>ISIN</th>
        <th>Security Name</th>
        <th>Shares</th>
        <th>Scope 1</th>
        <th>Scope 2</th>
        <th>Scope 3</th>
        <th>Overall</th>
        <th>Revenue</th>
        <th>total_scope_1</th>
        <th>total_scope_2</th>
        <th>total_scope_3</th>
        <th>total_overall</th>
        <th>total_revenue</th>
        <th>alternative</th>
      </tr>
      <tbody>
        <tr v-for="(contract, index) in result.contracts" :key="index">
          <td>{{ contract.platform_contract_name }}</td>
          <td>{{ contract.platform_name }}</td>
          <td>{{ contract.contract_name }}</td>
          <td>{{ contract.amount }}</td>
          <td>{{ contract.securities[index].isin }}</td>
          <td>{{ contract.securities[index].name }}</td>
          <td>{{ contract.securities[index].shares }}</td>
          <td>{{ contract.securities[index].scope_1 }}</td>
          <td>{{ contract.securities[index].scope_2 }}</td>
          <td>{{ contract.securities[index].scope_3 }}</td>
          <td>{{ contract.securities[index].overall }}</td>
          <td>{{ contract.securities[index].revenue }}</td>
          <td>{{ contract.total_scope_1 }}</td>
          <td>{{ contract.total_scope_2 }}</td>
          <td>{{ contract.total_scope_3 }}</td>
          <td>{{ contract.total_overall }}</td>
          <td>{{ contract.total_revenue }}</td>
          <td>{{ contract.alternative }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import axios from "axios";
import BtnLauch from "./BtnLauch.vue";
import RenderResult from "./RenderResult.vue";

export default {
  props: {
    scan: {
      require: true,
    },
    positions: {
      require: true,
    },
    user: {
      require: true,
    },
  },
  data() {
    return {
      isLoading: false,
      fileContent: "",
      result: "",
      time: 0,
      timer: null,
    };
  },
  mounted() {
    this.getFileContent();
    setInterval(() => {
      this.getFileContent();
    }, 1000);
    setTimeout(() => {
      this.lauchScript();
    }, 1500);
  },
  methods: {
    async lauchScript() {
      this.isLoading = true;
      this.resetTimer();
      this.startTimer();
      try {
        await this.scan(`/api/v1/analyze_carbon?api_token=${this.user.api_token}`).then((response) => {
          console.log(response.data);
          this.result = response.data.result;
        });
        this.getFileContent();
      } catch (error) {
        console.error(error);
      } finally {
        this.stopTimer();
        this.isLoading = false;
      }
    },
    async getFileContent() {
      if (this.user !== null && this.user !== undefined) {
        try {
          const response = await axios.get(`/scanner/showFile/${this.user.id}/log_AnalyzeCarbon`);
          this.fileContent = response.data.replace(/{"date":/g, '</br> {"date":').replace(/{"src"/g, '</br> {"src"');
        } catch (error) {
          console.error(error);
        }
      }
    },
    startTimer() {
      this.timer = setInterval(() => {
        this.time++;
      }, 1000);
    },
    stopTimer() {
      clearInterval(this.timer);
      //   this.resetTimer();
    },
    resetTimer() {
      this.time = 0;
    },
  },
  components: { BtnLauch, RenderResult },
};
</script>
